import React from "react";
import {Grid, Box, Typography, CircularProgress, Backdrop} from "@mui/material";
import FilterAccordion from "../FilterAccordion";
import { COLORS } from "../../constants";
import useSystemHook from "./../../hooks/SystemHook";

const GridFilters = ({
  productCategoriesListToUse,
  changePageCategory,
  showMoreCategories,
  showAllCategories,
  activeFilters,
  productTypesListToUse,
  changePageProductType,
  showMoreTypes,
  showAllTypes,
  clearPageProductType,
  vendorOptions,
  makeOptions,
  modelOptions,
  variantOptions,
  yearOptions,
  handleFilterChange,
  categoryOptions,
  clearFilter,
  filtersLoading,
}) => {
  const { isMobile, isTablet, isDesktop } = useSystemHook();

  return (
      <>
          <Grid
              spacing={2}
              sx={{
                  backgroundColor: COLORS.white,
                  height: "100%",
                  border: isMobile ? "none" : `1px solid ${COLORS.border}`,
                  borderRadius: "2px",
                  p: isMobile ? 0 : 2,
              }}
          >
              <Grid item xs={12}>
                  <FilterAccordion
                      name="vendor"
                      title="Vendor"
                      options={vendorOptions}
                      activeFilters={activeFilters}
                      onFilterChange={handleFilterChange}
                  />
              </Grid>

              {!!makeOptions.length && (
                  <Grid item xs={12}>
                      <FilterAccordion
                          name="make"
                          title="Make"
                          options={makeOptions}
                          activeFilters={activeFilters}
                          onFilterChange={handleFilterChange}
                      />
                  </Grid>
              )}

              {!!modelOptions.length && (
                  <Grid item xs={12}>
                      <FilterAccordion
                          name="model"
                          title="Model"
                          options={modelOptions}
                          activeFilters={activeFilters}
                          onFilterChange={handleFilterChange}
                      />
                  </Grid>
              )}

              {!!variantOptions.length && (
                  <Grid item xs={12}>
                      <FilterAccordion
                          name="variant"
                          title="Variant"
                          options={variantOptions}
                          activeFilters={activeFilters}
                          onFilterChange={handleFilterChange}
                      />
                  </Grid>
              )}

              {!!yearOptions.length && (
                  <Grid item xs={12}>
                      <FilterAccordion
                          name="year"
                          title="Year"
                          options={yearOptions}
                          activeFilters={activeFilters}
                          onFilterChange={handleFilterChange}
                      />
                  </Grid>
              )}
          </Grid>
          {filtersLoading && <CircularProgress color="inherit" />}
      </>
  );
};

export default GridFilters;
